import { render, staticRenderFns } from "./CompactCard.vue?vue&type=template&id=87c76ac4&scoped=true&"
import script from "./CompactCard.vue?vue&type=script&lang=js&"
export * from "./CompactCard.vue?vue&type=script&lang=js&"
import style0 from "./CompactCard.vue?vue&type=style&index=0&id=87c76ac4&scoped=true&lang=css&"
import style1 from "./CompactCard.vue?vue&type=style&index=1&id=87c76ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c76ac4",
  null
  
)

export default component.exports